import { Component } from '@angular/core';

@Component({
    selector: 'app-expired',
    templateUrl: './expired.component.html',
    styleUrls: ['./expired.component.css'],
    standalone: false
})
export class ExpiredComponent {

}
